import { Injectable } from "@angular/core";
import { timer, BehaviorSubject, Subject, of } from "rxjs";
import { ProcessStateService } from "../../../swaggerServices";
import { concatMap, catchError } from "rxjs/operators";

@Injectable()
export class ProcessStatePollingService {
  private pollingList = {};
  private processStateSubjectList = {};
  private processStateList = {};
  constructor(private processStateService: ProcessStateService) {}

  startPolling(
    processName,
    entity,
    entityId,
    pollFrequency = 10000,
    retry = 0
  ) {
    let retryAttempt = 0;
    const processKey = this.processKey(processName, entity, entityId);
    this.initProcessSubject(processKey);
    const polling$ = timer(0, pollFrequency)
      .pipe(
        concatMap(_ => {
          return this.processStateService
            .getEntityProcessState(processName, entity, entityId)
            .pipe(
              catchError(err => {
                if (err && err.status === 502 && retryAttempt < retry) {
                  retryAttempt++;
                  console.log(
                    `Retrying process ${processName} for entity ${entity} with id ${entityId} because of error ${JSON.stringify(
                      err
                    )}`
                  );
                  return of(undefined);
                } else {
                  this.cancelPolling(processName, entity, entityId);
                  return of(undefined);
                }
              })
            );
        })
      )
      .subscribe(response => {
        this.processStateSubjectList[processKey].next(response);
      });
    this.pollingList[processKey] = polling$;
    return this.processStateList[processKey];
  }

  subscribeData(processName, entity, entityId) {
    const processKey = this.processKey(processName, entity, entityId);
    if (!this.processStateList[processKey]) {
      this.initProcessSubject(processKey);
    }
    return this.processStateList[processKey];
  }

  cancelPolling(processName, entity, entityId) {
    const processKey = this.processKey(processName, entity, entityId);
    if (this.pollingList[processKey]) {
      this.pollingList[processKey].next();
      this.pollingList[processKey].complete();
      delete this.pollingList[processKey];
    }

    if (this.processStateSubjectList[processKey]) {
      this.processStateSubjectList[processKey].next();
      this.processStateSubjectList[processKey].complete();
      delete this.processStateSubjectList[processKey];
    }

    if (this.processStateList[processKey]) {
      delete this.processStateList[processKey];
    }
  }

  private initProcessSubject(processKey) {
    if (
      !this.processStateSubjectList[processKey] ||
      !this.processStateList[processKey]
    ) {
      this.processStateSubjectList[processKey] = new BehaviorSubject("");
      this.processStateList[processKey] = this.processStateSubjectList[
        processKey
      ].asObservable();
    }
  }

  private processKey(processName, entity, entityId) {
    return `${processName}_${entity}_${entityId}`;
  }
}
